import { useState } from "react"

export const useDate = (value) => {
    
    const [date, setDate] = useState('') 
    const handleDate = (unformattedDate, setFieldValue) => {
        setDate(unformattedDate)
        if(unformattedDate.includes('-')){
            console.log('sin formato: ',  unformattedDate.split('-').join(''))
            setFieldValue(value, unformattedDate.split('-').join(''))
        }
    }

    return [date, handleDate]
}